import { render, staticRenderFns } from "./wajue.vue?vue&type=template&id=9f0a657a&scoped=true&"
import script from "./wajue.vue?vue&type=script&lang=ts&"
export * from "./wajue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0a657a",
  null
  
)

export default component.exports